<template>
  <div class="InspectRoom">
    <!-- 导航栏 -->
    <Header @back="router.go(-1)" />

    <div class="content">
      <div class="content-title">{{ stringList.InspectRoom }}</div>
      <a-form :form="form" @submit="handleSubmit" ref="formRef">
        <a-form-item class="formItem" :label="stringList.room">
          <a-select
            show-search
            size="large"
            dropdownClassName="num-drop"
            :placeholder="stringList.EnterRoom"
            v-decorator="[
              'roomNumber',
              {
                rules: [
                  { required: true, message: stringList['select_enter_room#'] },
                ],
              },
            ]"
          >
            <a-select-option
              v-for="item in roomArray"
              :key="item.id"
              :value="item.name"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <!-- <a-form-item class="formItem" label=" ">
          <div class="room-type">
            <a-radio-group
              v-decorator="[
                'vacant',
                {
                  initialValue: true,
                },
              ]"
            >
              <a-radio style="display: block" :value="true">
                {{ stringList.vacant_checked_out }}
              </a-radio>
              <a-radio style="display: block; margin-top: 8px" :value="false">
                {{ stringList.occupied_stay_over }}
              </a-radio>
            </a-radio-group>
          </div>
        </a-form-item> -->

        <a-form-item class="formItem" :label="stringList.CleanBy">
          <!-- <a-cascader
            v-decorator="[
              'cleanerId',
              {
                rules: [{ required: true, message: stringList.InvalidCleanBy }],
              },
            ]"
            :options="departmentUserOptions"
            :placeholder="stringList.TypeSelectItem"
          /> -->
          <a-select
            show-search
            option-filter-prop="label"
            v-decorator="[
              'cleanerId',
              {
                rules: [{ required: true, message: stringList.TypeSelectName }],
              },
            ]"
            :placeholder="stringList.TypeSelectName"
          >
            <a-select-option
              :value="item.value"
              v-for="(item, index) in departmentUserOptions"
              :key="index"
              :label="item.label"
              >{{ item.label }}</a-select-option
            >
          </a-select>
        </a-form-item>
      </a-form>
    </div>
    <div class="footer">
      <van-button
        :spinning="true"
        class="button"
        @click="handleSubmit"
        native-type="submit"
        >{{ stringList.start }}</van-button
      >
    </div>

    <Copyright />
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import Copyright from "@/components/Copyright.vue";
import { getAction } from "@/api/manage";

import { mapGetters } from "vuex";
export default {
  name: "InspectRoom",
  components: { Header, Copyright },
  data() {
    return {
      form: this.$form.createForm(this, { name: "InspectRoom" }),
      roomArray: [], // 房间信息
      departmentUserOptions: [], // 人员信息
    };
  },
  computed: {
    ...mapGetters({
      stringList: "stringList",
      userInfo: "userInfo",
    }),
  },
  created() {
    this.getRoomArray();
    this.getDeptuser();
  },
  activated() {
    if (["/home"].includes(this.$store.state.router.routeFromPath)) {
      // 重置表单
      this.form = this.$form.createForm(this, { name: "InspectRoom" });
      this.getRoomArray();
      this.getDeptuser();
    }
  },
  deactivated() {
    //
  },
  methods: {
    async getRoomArray() {
      const { data } = await getAction(
        `/api/sys_admin/hotel/room/query2/guest/allmeeting`
      );
      this.roomArray = data;
    },
    async getDeptuser() {
      const { data } = await getAction(
        `/api/sys_admin/deptuser/query/${this.userInfo.hotelId}`
      );

      let HousekeepingUsers = data.find(
        (item) => item.deptName === "Housekeeping"
      ).userList;
      let list = HousekeepingUsers.map((item) => {
        return {
          label: `${item.firstName} ${item.lastName}`,
          value: item.id,
          text: `${item.firstName} ${item.lastName}`,
        };
      });

      list.unshift({
        label: this.stringList.Unknown,
        value: "Unknown",
        text: "Unknown",
      });

      this.departmentUserOptions = list;

      this.form.setFieldsValue({
        cleanerId: "Unknown",
      });
    },

    findItemByValuePath(valuePath, options, currentPath = []) {
      if (!valuePath || valuePath.length === 0) return [];

      const currentValue = valuePath[0];
      const node = options.find((item) => item.value === currentValue);

      if (!node) return [];

      const newPath = [...currentPath, node];

      if (valuePath.length === 1) {
        return newPath; // 找到最终节点
      } else if (node.children) {
        return this.findItemByValuePath(
          valuePath.slice(1),
          node.children,
          newPath
        );
      } else {
        return []; // 路径不匹配
      }
    },

    async handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          //
          console.log("表单值:", values);

          let dataForm = JSON.parse(JSON.stringify(values));
          // let selectedItemPath = this.findItemByValuePath(
          //   dataForm.cleanerId,
          //   this.departmentUserOptions
          // );
          // const { label, value } =
          //   selectedItemPath[selectedItemPath.length - 1];

          this.$router.replace({
            path: "/InspectRoomArea",
            query: {
              dataForm: JSON.stringify({
                ...dataForm,
                cleanerId:
                  dataForm.cleanerId === "Unknown" ? "" : dataForm.cleanerId,
                cleanerName:
                  dataForm.cleanerId === "Unknown"
                    ? ""
                    : this.departmentUserOptions.find(
                        (item) => item.value === dataForm.cleanerId
                      ).label,
                startCheckTime: new Date(),
              }),
            },
          });
        }
      });
    },
  },
};
</script>
<style lang="scss">
.ant-select-dropdown-menu-item {
  color: #050101 !important;
  font-size: 16px;
}
</style>
<style lang="scss" scoped>
.formItem {
  display: flex;
  align-items: flex-start;
  margin: 16px 0 20px;
  /deep/.ant-form-item-label {
    width: 84px;
    flex-shrink: 0;
    padding-bottom: 0 !important;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    // padding-right: 5px;

    label {
      font-size: 16px;
      font-weight: normal;
      color: #050101;
      line-height: 1.2;
      word-break: keep-all !important;
      white-space: normal !important;
      text-align: left;
    }
  }

  /deep/.ant-form-item-control-wrapper {
    flex: 1;
  }

  /deep/.ant-form-item-required::before {
    display: none !important;
  }

  /deep/.ant-select {
    width: 100% !important;

    .ant-select-selection {
      height: 48px !important;

      .ant-select-selection__rendered {
        line-height: 48px !important;
        margin-left: 24px !important;
        justify-content: flex-start;

        .ant-select-selection-selected-value {
          font-size: 16px;
          font-weight: normal;
          color: #000000;
        }
      }

      .ant-select-selection__placeholder {
        color: #767676;
        font-size: 16px;
        text-align: left !important;
      }
    }
  }

  /deep/.ant-cascader-picker {
    width: 100% !important;

    .ant-input {
      height: 48px !important;
      padding-left: 24px;
    }

    .ant-cascader-picker-label {
      padding-left: 24px;
      text-align: left !important;
      font-size: 16px;
      font-weight: normal;
      color: #000000;
    }
  }

  /deep/.has-error {
    position: relative;
    .ant-form-explain {
      font-family: Arial;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      margin-top: 6px;
      letter-spacing: 0em;
      display: flex;
      color: #df714f;
      justify-content: center;
    }

    .ant-select-selection,
    .ant-input {
      box-shadow: none;
      background: #fee0d6 !important;
      border: 1px solid #df714f !important;
    }

    .ant-select-selection__placeholder,
    .ant-cascader-picker-label {
      color: #df714f !important;
    }

    input::placeholder {
      color: #df714f !important;
    }
  }
}
.InspectRoom {
  flex: 1;
  background-color: #f2f2f2;

  .content {
    height: 284px;
    padding: 24px 1.75rem;
    opacity: 1;
    background: #ffffff;

    .content-title {
      height: 26px;
      opacity: 1;
      font-family: Arial;
      font-size: 22px;
      font-weight: 700;
      line-height: 24px;
      letter-spacing: 0em;
      color: #5a578c;
      margin-bottom: 32px;
    }
  }
}

.room-type {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .label {
    opacity: 1;
    font-family: Arial;
    font-size: 16px;
    line-height: 26px;
    display: flex;
    align-items: center;
    color: #101010;
  }
  .ant-radio-group {
    /deep/span:not(ant-radio) {
      opacity: 1;
      font-family: Arial;
      font-size: 14px;
      font-weight: 400;
      line-height: 26px;
      letter-spacing: 0em;
      color: #101010;
      z-index: 1;
    }
    /deep/.ant-radio-inner {
      width: 14px;
      height: 14px;
    }
    /deep/.ant-radio-wrapper {
      display: flex !important;
      align-items: center;
    }
    /deep/.ant-radio-wrapper-checked {
      .ant-radio-inner::after {
        background: #afafaf;
      }
      .ant-radio-inner {
        border-color: #afafaf;
      }
      .ant-radio-inner::after {
        transform: translate(-11.5%, -11.5%);
      }
    }
  }
}

.footer {
  margin: 24px auto 32px;
  .button {
    width: 200px;
    height: 48px;
    border-radius: 8px;
    opacity: 1;
    background: #ff6600;
    font-family: Arial;
    font-size: 16px;
    font-weight: 700;
    line-height: 18.72px;
    text-align: center;
    // display: flex;
    // align-items: center;
    letter-spacing: 0em;
    color: #ffffff;
    border: 0;
  }
}
</style>
